import {
  CountryDTO, type Country,
  LanguageDTO, type Language,
  LocationDTO, type Location,
  AccomodationPlaceDTO, type AccomodationPlace,
  ReportMailDTO, type ReportMail,
} from '../../api/schemas/entities.ts';
import type { CrudConfig } from './GenericCrud.tsx';

export const countriesConfig: CrudConfig<Country> = {
  title: 'Countries',
  resource: 'countries',
  schema: CountryDTO,
  columns: [
    { key: 'name', header: 'Name' },
    { key: 'region', header: 'Region' },
  ],
  fields: [
    { kind: 'text', key: 'name', label: 'Name', required: true },
    { kind: 'text', key: 'region', label: 'Region' },
  ],
  emptyValues: { name: '', region: '' },
};

export const languagesConfig: CrudConfig<Language> = {
  title: 'Languages',
  resource: 'languages',
  schema: LanguageDTO,
  columns: [{ key: 'name', header: 'Name' }],
  fields: [{ kind: 'text', key: 'name', label: 'Name', required: true }],
  emptyValues: { name: '' },
};

export const locationsConfig: CrudConfig<Location> = {
  title: 'Locations',
  resource: 'locations',
  schema: LocationDTO,
  columns: [
    { key: 'name', header: 'Name' },
    { key: 'description', header: 'Description' },
  ],
  fields: [
    { kind: 'text', key: 'name', label: 'Name', required: true },
    { kind: 'text', key: 'description', label: 'Description' },
  ],
  emptyValues: { name: '', description: '' },
};

export const accomodationPlacesConfig: CrudConfig<AccomodationPlace> = {
  title: 'Accommodation places',
  resource: 'accomodation-places',
  schema: AccomodationPlaceDTO,
  columns: [
    { key: 'name', header: 'Name' },
    { key: 'address', header: 'Address' },
    { key: 'comments', header: 'Comments' },
  ],
  fields: [
    { kind: 'text', key: 'name', label: 'Name', required: true },
    { kind: 'text', key: 'address', label: 'Address' },
    { kind: 'text', key: 'comments', label: 'Comments' },
    { kind: 'number', key: 'locationId', label: 'Location id' },
  ],
  emptyValues: { name: '', address: '', comments: '', locationId: null },
};

import { createElement } from 'react';
import { IconSend } from '@tabler/icons-react';
import { notifications } from '@mantine/notifications';
import { api } from '../../api/client.ts';

export const reportMailsConfig: CrudConfig<ReportMail> = {
  title: 'Report Mails',
  resource: 'report-mails',
  schema: ReportMailDTO,
  columns: [
    { key: 'email', header: 'Email' },
    { key: 'report', header: 'Report' },
    { key: 'location', header: 'Location' },
    { key: 'period', header: 'Period' },
    { key: 'hour', header: 'Hour' },
    { key: 'format', header: 'Format' },
  ],
  fields: [
    { kind: 'text', key: 'email', label: 'Email', required: true },
    { kind: 'text', key: 'report', label: 'Report (arrival|departure|stay|train)' },
    { kind: 'text', key: 'location', label: 'Location' },
    { kind: 'number', key: 'period', label: 'Period (days; 7 = weekly)' },
    { kind: 'number', key: 'hour', label: 'Hour of day (or day-of-week 1..7 for weekly)' },
    { kind: 'text', key: 'format', label: 'Format (xlsx)' },
    { kind: 'text', key: 'extraParams', label: 'Extra params' },
  ],
  emptyValues: { email: '', report: 'arrival', location: '', period: 1, hour: 9, format: 'xlsx', extraParams: '' },
  rowActions: [
    {
      label: 'Send now',
      icon: createElement(IconSend, { size: 16 }),
      onRun: async row => {
        if (row.id == null) return;
        const res = await api.post(`/api/report-mails/${row.id}/run-now`, {});
        if (res.status === 200) {
          notifications.show({
            message: `Report sent — check ${row.email ?? 'your inbox'}`,
            color: 'green',
          });
        } else {
          const detail = (res.data as { error?: string })?.error ?? `status ${res.status}`;
          notifications.show({ message: `Send failed: ${detail}`, color: 'red' });
        }
      },
    },
  ],
};
